import {
  faFileMedical,
  faPen,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BootCheckbox from "components/common/custom/forms/BootCheckbox";
import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import BootIconButton from "components/common/custom/IconButton";
import FalconCloseButton from "components/common/FalconCloseButton";
import FalconComponentCard from "components/common/FalconComponentCard";
import MultiSelect from "components/common/MultiSelect";
import WizardModal from "components/wizard/WizardModal";
import {
  claimSelectedTooth,
  handleAddClaimServices,
  resetSelectedService,
  setViewModal,
} from "features/cliams/config/claimSlice";
import MedicalHistoryMedicine from "features/preauthorization/components/MedicalHistoryMedicine";
import ServiceCodeSelect from "features/preauthorization/components/ServiceCodeSelect";
import TeethModalSelect from "features/preauthorization/components/TeethModalSelect";
import { GetAllBodySite } from "features/preauthorization/config/preauthorizationApi";

import { getToday, ShowError } from "helpers/utils";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaTooth } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

const ClaimMedicalHistoryModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const {
    selectedService,
    stepFormData,
    validationError,
    viewModal,
    practitionerListAdded,
    historyModalOpen,
    cliamServicesList,
    // durationList,
    selectedToothInfo,
    preauthorizationDiagnosis,
    doseList,
  } = useSelector((state) => state.claim);

  console.log({ selectedService });

  const {
    serviceTypeList,
    bodySite,
    bodySubSite,
    practitionerList,
    labTestList,
    oralDentalList,
  } = useSelector((state) => state.preauthorization);
  const { singleEligibilityData } = useSelector(
    (state) => state.eligibilityCheckList
  );

  const {
    watch,
    control,
    setValue,
    handleSubmit,
    reset,
    setError,
    formState: { errors, dirtyFields },
  } = useForm({
    defaultValues: {
      service_start_date: getToday(),
      service_end_date: getToday(),
      service_type: null,
      service_code_description: null,
      maternity: false,
      unit_price: "",
      discount: "",
      quantity: "",
      vat: "",
      net_amount: "",
      day_supply: "",
      preauthorization_ref_no: "",
      strength: "",
      body_site: null,
      oral_origin: null,
      sub_site: null,
      scientific_code: "",
      scientic_code_absence: "",
      selection_reason: "",
      pharmacist_substitute: "",
      start_date: null,
      end_date: null,
      duration: "",
      scientific_code_other_reason: "",
      substitute_reason_other: "",
      durationType: "",
      frequency: "",
      period_info: "",
      period_type: "",
      tooth_surface: null,
      oral_origin: null,
      dose_type: "",
      patient_share: "",
      refill_count: "",
      route: "",
      service_practitioner: null,
      time_instruction: "",
      dosage_instruction: "",
      patient_instruction: "",
      additional_supporting_info: "",
      diagnosis: [],
      lab_tests: [],
    },
  });
  const userModifiedPatientShare = useRef(false);
  const [searchParams] = useSearchParams();

  const { unit_price, discount, quantity, vat, patient_share } = watch();
  useEffect(() => {
    if (bodySite?.length === 0) {
      dispatch(GetAllBodySite());
    }
  }, []);

  const coverageEligibility =
    singleEligibilityData?.eligibility_response?.entry?.find(
      (item) => item?.resource?.resourceType === "Coverage"
    )?.resource;

  const eligibility = searchParams.get("eligibility") === "true";

  const beneficiaryCost = coverageEligibility?.costToBeneficiary;
  const watchedPatientShare = watch("patient_share");

  const isDental = stepFormData?.claim_type?.claim_types_name === "Dental";
  const serviceCodeDesc = watch("service_code_description");

  const [showServiceCodeModal, setShowServiceCodeMadal] = useState(false);
  const [menuStates, setMenuStates] = useState(false);
  const [teethModal, setTeethModal] = useState(false);

  const handleServiceMenuToggle = (isOpen) => {
    if (isOpen && !watch("service_type")) {
      setShowServiceCodeMadal(true);
      return setMenuStates(isOpen);
    }
    setMenuStates((prev) => ({ ...prev, type: isOpen }));
  };

  // Fetch required data when modal opens
  useEffect(() => {
    if (selectedToothInfo?.number) {
      setValue(
        "oral_origin",
        oralDentalList?.find(
          (item) => item?.oral_code == selectedToothInfo?.number
        )
      );
    }
  }, [selectedToothInfo, oralDentalList, setValue, isDental]);

  useEffect(() => {
    if (patient_share === "" || parseFloat(patient_share) === 0) {
      userModifiedPatientShare.current = false;
    } else {
      userModifiedPatientShare.current = true;
    }
  }, [patient_share]);

  useEffect(() => {
    userModifiedPatientShare.current = false;
  }, [unit_price, quantity, discount, vat]);

  useEffect(() => {
    const calculateAmounts = () => {
      const unitPriceVal = Number(unit_price) || 0;
      const discountVal = Number(discount) || 0;
      const quantityVal = Number(quantity) || 1;
      const vatVal = Number(vat) || 0;
      const formPatientShare = Number(watchedPatientShare) || 0;

      const total = unitPriceVal * quantityVal;
      const discountAmount = total * (discountVal / 100);
      const baseAmountAfterDiscount = Math.max(0, total - discountAmount);

      let calculatedPatientShare = 0;

      // Determine maxPatientShare based on eligibility
      let maxPatientShare = baseAmountAfterDiscount;
      if (singleEligibilityData?.eligibilityid || eligibility) {
        const maxCopayRaw = singleEligibilityData?.coverage_info?.maxlimit;
        const copayPctRaw = singleEligibilityData?.coverage_info?.deductable;

        console.log({ maxCopayRaw, copayPctRaw })

        const maxCopay = Number(maxCopayRaw) || Infinity;
        const copayPct = Number(copayPctRaw) || 0;

        const totalExistingPatientShare = cliamServicesList
          .filter((s) => s.id !== selectedService?.id)
          .reduce((sum, s) => sum + (Number(s.patient_share) || 0), 0);

        const remainingMaxCopay = Math.max(
          0,
          maxCopay - totalExistingPatientShare
        );

        maxPatientShare = Math.min(baseAmountAfterDiscount, remainingMaxCopay);

        const systemShare = Math.min(
          baseAmountAfterDiscount * (copayPct / 100),
          maxPatientShare
        );

        // If the field is not dirty, use systemShare, else respect user input
        if (!dirtyFields.patient_share) {
          calculatedPatientShare = Math.max(0, systemShare);
          if (Math.abs(formPatientShare - calculatedPatientShare) > 0.005) {
            setValue("patient_share", calculatedPatientShare.toFixed(2), {
              shouldValidate: true,
            });
          }
        } else {
          // field is dirty → user entered value, clamp 0-maxPatientShare
          calculatedPatientShare = Math.max(
            0,
            Math.min(formPatientShare, baseAmountAfterDiscount)
          );
          if (formPatientShare > baseAmountAfterDiscount + 0.005) {
            setValue("patient_share", baseAmountAfterDiscount.toFixed(2), {
              shouldValidate: true,
            });
          }
        }
      } else {
        // No eligibility → allow 0, clamp at baseAmountAfterDiscount
        const maxNoElig = baseAmountAfterDiscount;

        calculatedPatientShare = Math.max(
          0,
          Math.min(formPatientShare, maxNoElig)
        );
        if (formPatientShare > maxNoElig + 0.005) {
          setValue("patient_share", maxNoElig.toFixed(2), {
            shouldValidate: true,
          });
        }
      }

      // final clamp for safety
      calculatedPatientShare = Math.min(
        calculatedPatientShare,
        baseAmountAfterDiscount
      );
      calculatedPatientShare = Math.max(0, calculatedPatientShare);

      // compute net
      const baseAmount = baseAmountAfterDiscount - calculatedPatientShare;
      const calculatedNetAmount = (baseAmount * (1 + vatVal / 100)).toFixed(2);

      setValue("net_amount", calculatedNetAmount, { shouldValidate: true });
    };

    if (
      dirtyFields?.quantity ||
      dirtyFields?.discount ||
      dirtyFields?.vat ||
      dirtyFields?.unit_price ||
      dirtyFields?.net_amount ||
      dirtyFields?.patient_share
    ) {
      calculateAmounts();
    } else {
      calculateAmounts();
    }
  }, [
    unit_price,
    quantity,
    discount,
    vat,
    watchedPatientShare,
    singleEligibilityData,
    historyModalOpen,
    cliamServicesList,
    selectedService,
    selectedService?.id,
    setValue,
    beneficiaryCost,
    eligibility,
    dirtyFields.patient_share, // important to track dirty state
  ]);

  useEffect(() => {
    if (serviceCodeDesc && !selectedService?.id) {
      setValue("unit_price", serviceCodeDesc?.unit_price || "");
      setValue("discount", serviceCodeDesc?.price_discount || 0);
      setValue("vat", serviceCodeDesc?.price_tax || "");
      setValue("strength", serviceCodeDesc?.prodserv_strngt || "");
      setValue("quantity", 1);
      // Don't reset patient_share here
    }
  }, [serviceCodeDesc, selectedService?.id, setValue]);

  useEffect(() => {
    if (!serviceCodeDesc) {
      setValue("unit_price", "");
      setValue("discount", "");
      setValue("vat", "");
      setValue("net_amount", "");
      setValue("quantity", 1);
      setValue("patient_share", "");
    }
  }, [serviceCodeDesc, setValue]);

  // Set default diagnosis and lab tests in add mode
  useEffect(() => {
    if (!selectedService?.id) {
      setValue("quantity", 1);
      if (
        preauthorizationDiagnosis?.length > 0 &&
        !watch("diagnosis")?.length
      ) {
        const principalDiagnoses = preauthorizationDiagnosis.filter(
          (d) => d.type === "principal"
        );
        if (principalDiagnoses.length > 0) {
          setValue(
            "diagnosis",
            principalDiagnoses.map((d) => ({
              code: d.code,
              description: d.description,
            }))
          );
        }
      }

      if (labTestList?.length > 0 && !watch("lab_tests")?.length) {
        setValue(
          "lab_tests",
          labTestList.map((test) => test.lab_test_code)
        );
      }
    }
  }, [
    preauthorizationDiagnosis,
    labTestList,
    selectedService?.id,
    setValue,
    watch,
  ]);
  useEffect(() => {
    if (selectedService?.id) {
      console.log({ selectedService });
      setValue(
        "service_start_date",
        selectedService?.service_start_date || getToday()
      );
      setValue(
        "service_end_date",
        selectedService?.service_end_date || getToday()
      );
      setValue("service_type", selectedService?.service_type || null);
      setValue(
        "service_code_description",
        selectedService?.service_code_description || null
      );
      setValue("maternity", selectedService?.maternity || false);
      setValue("unit_price", selectedService?.unit_price || "");
      setValue("discount", selectedService?.discount || 0);
      setValue("quantity", selectedService?.quantity || 0);
      setValue("vat", selectedService?.vat || "");
      setValue("net_amount", selectedService?.net_amount || "");
      setValue("patient_share", selectedService?.patient_share || "0");
      setValue("day_supply", selectedService?.day_supply || "");
      setValue(
        "preauthorization_ref_no",
        selectedService?.preauthorization_ref_no || ""
      );
      setValue("strength", selectedService?.strength || "");
      setValue("body_site", selectedService?.body_site || null);
      setValue("sub_site", selectedService?.sub_site || null);
      setValue("scientific_code", selectedService?.scientific_code || "");
      setValue(
        "scientic_code_absence",
        selectedService?.scientic_code_absence || ""
      );
      setValue("selection_reason", selectedService?.selection_reason || "");
      setValue(
        "pharmacist_substitute",
        selectedService?.pharmacist_substitute || ""
      );
      setValue(
        "prescribed_medication_code",
        selectedService?.prescribed_medication_code || null
      );
      setValue(
        "prescribed_medication_type",
        selectedService?.prescribed_medication_type || ""
      );
      setValue("start_date", selectedService?.start_date || null);
      setValue("end_date", selectedService?.end_date || null);
      setValue(
        "scientific_code_other_reason",
        selectedService?.scientific_code_other_reason || ""
      );
      setValue(
        "substitute_reason_other",
        selectedService?.substitute_reason_other || ""
      );
      setValue("duration", selectedService?.duration || "");
      setValue(
        "durationType",
        selectedService?.duration_type || selectedService?.durationType || ""
      );
      setValue("frequency", selectedService?.frequency || "");
      setValue("period_info", selectedService?.period_info || "");
      setValue(
        "frequencyType",
        selectedService?.period_type || selectedService?.frequencyType || ""
      );
      setValue("diagnosis", selectedService?.diagnosis || "");
      setValue("tooth_surface", selectedService?.tooth_surface || null);
      setValue("oral_origin", selectedService?.oral_origin || null);
      setValue("invoice_no", selectedService?.invoice_no || "");
      setValue("dose", selectedService?.dose || "");
      setValue(
        "doseType",
        selectedService?.dose_type || selectedService?.doseType || ""
      );
      setValue("refill_count", selectedService?.refill_count || "");
      setValue("route", selectedService?.route || "");
      setValue(
        "service_practitioner",
        selectedService?.service_practitioner || ""
      );
      setValue("time_instruction", selectedService?.time_instruction || "");
      setValue("dosage_instruction", selectedService?.dosage_instruction || "");
      setValue(
        "patient_instruction",
        selectedService?.patient_instruction || ""
      );
      setValue(
        "additional_supporting_info",
        selectedService?.additional_supporting_info || ""
      );
    } else {
      reset({
        service_start_date: getToday(),
        service_end_date: getToday(),
        service_type: null,
        service_code_description: null,
        maternity: false,
        unit_price: "",
        discount: "",
        quantity: "",
        vat: "",
        net_amount: "",
        patient_share: "",
        day_supply: "",
        preauthorization_ref_no: "",
        strength: "",
        body_site: null,
        sub_site: null,
        scientific_code: "",
        scientic_code_absence: "",
        selection_reason: "",
        pharmacist_substitute: "",
        prescribed_medication_code: "",
        prescribed_medication_type: "",
        start_date: null,
        end_date: null,
        duration: "",
        durationType: "",
        frequency: "",
        frequencyType: "",
        period_info: "",
        diagnosis: "",
        tooth_surface: null,
        oral_origin: null,
        dose: "",
        doseType: "",
        refill_count: "",
        route: "",
        service_practitioner: "",
        time_instruction: "",
        dosage_instruction: "",
        patient_instruction: "",
        additional_supporting_info: "",
        scientific_code_other_reason: "",
        substitute_reason_other: "",
        invoice_no: "",
      });
      dispatch(resetSelectedService());
    }
  }, [selectedService, setValue, reset]);

  // Set default practitioner
  useEffect(() => {
    if (show && !selectedService?.id) {
      // Set principal diagnosis by default
      const principalDiag = preauthorizationDiagnosis?.find(
        (item) => item.type === "principal"
      );
      if (principalDiag) {
        setValue("diagnosis", [
          { code: principalDiag.code, description: principalDiag.description },
        ]);
      }

      // Set first practitioner from practitionerListAdded by default
      if (practitionerListAdded?.length > 0) {
        const firstItem = practitionerListAdded?.find(
          (item) => item?.role?.careroles_code?.toLowerCase() === "primary"
        );
        setValue("service_practitioner", {
          value: firstItem.practitioner.value,
          label: firstItem.practitioner.label,
        });
      }
    }
  }, [
    show,
    selectedService,
    preauthorizationDiagnosis,
    practitionerListAdded,
    setValue,
  ]);

  const addServices = (data) => {
    let hasError = false;

    if (data.service_start_date && data.service_end_date) {
      const startDate = new Date(data.service_start_date);
      const endDate = new Date(data.service_end_date);

      if (startDate > endDate) {
        setError("service_start_date", {
          type: "manual",
          message: "Start date cannot be after end date",
        });
        setError("service_end_date", {
          type: "manual",
          message: "End date cannot be before start date",
        });
        hasError = true;
      }
    }

    if (data?.unit_price < 1) {
      setError("unit_price", {
        type: "validate",
        message: "Unit Price can't be 0 or negative",
      });
      hasError = true;
    }
    if (data?.service_type?.servtype_code === "itm_medcde" && !data?.strength) {
      setError("strength", {
        type: "validate",
        message: "Strength is required when service type is medical code ",
      });
      hasError = true;
    }
    if (
      data?.service_type?.servtype_code === "itm_hrblcde" &&
      !data?.strength
    ) {
      setError("strength", {
        type: "validate",
        message: "Strength is required when service type is Herbal ",
      });
      hasError = true;
    }

    if (data?.quantity < 1) {
      setError("quantity", {
        type: "validate",
        message: "Quantity can't be 0 or negative",
      });
      hasError = true;
    }

    if (hasError || validationError) return;

    dispatch(
      handleAddClaimServices({
        type:
          selectedService?.invoice_no || selectedService?.id
            ? "EDIT_SERVICES"
            : "ADD_SERVICES",
        payload: {
          id:
            selectedService?.id ||
            `${data?.service_code_description?.prodserv_code}-${data?.service_start_date}`,
          ...data,
        },
      })
    );

    onHide();
    reset();
  };
  console.log({ cliamServicesList });
  return (
    <>
      <Modal show={show} fullscreen={false} dialogClassName="fullscreen-modal">
        <Form onSubmit={handleSubmit(addServices)}>
          <Modal.Header className="d-flex justify-content-between align-items-center ps-4 pe-4 pt-3">
            <Modal.Title as="h5" className="text-600 fs-11">
              <FontAwesomeIcon icon={faFileMedical} className="me-2" />
              {viewModal
                ? "View"
                : selectedService?.invoice_no || selectedService?.id
                  ? "Edit"
                  : "Add"}{" "}
              Service
            </Modal.Title>
            <FalconCloseButton
              size="sm"
              onClick={() => {
                reset();
                dispatch(resetSelectedService());
                onHide();
                dispatch(claimSelectedTooth(null));

                dispatch(setViewModal(false));
              }}
              className="position-relative"
            />
          </Modal.Header>
          <Modal.Body className="p-3">
            <Row className="g-3">
              <Col xs={12} sm={12} xl={6}>
                <Row>
                  <Col xs={12} xl={4}>
                    <BootDatePicker
                      name="service_start_date"
                      label="Start Date"
                      size="sm"
                      control={control}
                      rules={{ required: true }}
                      selected={watch("service_start_date")}
                      isClearable={true}
                      disabled={viewModal}
                      onChange={(date) => setValue("service_start_date", date)}
                      placeholder="dd/mm/yyyy"
                      dateFormat="dd-mm-yyyy"
                    />
                  </Col>
                  <Col xs={12} xl={4}>
                    <BootDatePicker
                      name="service_end_date"
                      label="End Date"
                      size="sm"
                      control={control}
                      rules={{ required: true }}
                      selected={watch("service_end_date")}
                      disabled={viewModal}
                      isClearable={true}
                      onChange={(date) => setValue("service_end_date", date)}
                      placeholder="dd/mm/yyyy"
                      dateFormat="dd-mm-yyyy"
                    />
                  </Col>
                  <Col xs={12} xl={4}>
                    <label className="form-label">
                      Service Type <span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="service_type"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <MultiSelect
                          {...field}
                          menuPlacement="auto"
                          closeMenuOnSelect={false}
                          isMulti={false}
                          options={serviceTypeList?.map((item) => ({
                            value: item.servtype_code,
                            label: item.servtype_name,
                          }))}
                          disabled={viewModal}
                          value={
                            field.value
                              ? {
                                value: field.value.servtype_code,
                                label: field.value.servtype_name,
                              }
                              : null
                          }
                          onChange={(selected) => {
                            setValue(
                              "service_type",
                              selected
                                ? {
                                  servtype_code: selected.value,
                                  servtype_name: selected.label,
                                }
                                : null
                            );
                          }}
                          formatOptionLabel={({ label }) => <div>{label}</div>}
                          getOptionValue={(option) => option.value}
                          placeholder="Choose ..."
                        />
                      )}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={12} xl={6}>
                <Row>
                  <Col xs={10}>
                    <ServiceCodeSelect
                      control={control}
                      label="Service Code Description"
                      name="service_code_description"
                      selectedServiceType={watch("service_type")?.servtype_code}
                      setValue={setValue}
                      isRequired={true}
                      watch={watch}
                      handleServiceMenuToggle={handleServiceMenuToggle}
                    />
                  </Col>
                  <Col xs={2}>
                    <BootCheckbox
                      name="maternity"
                      label="Maternity"
                      control={control}
                      disabled={viewModal}
                      size="lg"
                    />
                  </Col>
                </Row>
              </Col>
              <Col xs={12} md={6}>
                <FalconComponentCard className="custom-card">
                  <FalconComponentCard.Body className="custom-body">
                    <Row>
                      <Col xs={6} md={2}>
                        <TextInput
                          name="unit_price"
                          label="Unit Price"
                          control={control}
                          size="sm"
                          type="number"
                          disabled={viewModal}
                          min={0}
                          rules={{ required: true }}
                          required={true}
                        />
                      </Col>
                      <Col xs={6} md={2}>
                        <TextInput
                          name="discount"
                          label="Discount %"
                          control={control}
                          size="sm"
                          type="number"
                          disabled={viewModal}
                          min={0}
                          max={100}
                          rules={{ required: true }}
                          required={true}
                        />
                      </Col>
                      <Col xs={6} md={2}>
                        <TextInput
                          name="quantity"
                          label="Quantity"
                          control={control}
                          size="sm"
                          type="number"
                          min={0}
                          disabled={viewModal}
                          rules={{ required: true }}
                          required={true}
                        />
                      </Col>
                      <Col xs={6} md={2}>
                        <TextInput
                          name="patient_share"
                          label="Patient Share"
                          control={control}
                          size="sm"
                          type="number"
                          min={0}
                          disabled={viewModal}
                          rules={{ required: false }}
                          required={false}
                        />
                      </Col>
                      <Col xs={6} md={2}>
                        <TextInput
                          name="net_amount"
                          label="Net Amount"
                          control={control}
                          size="sm"
                          disabled
                          rules={{ required: true }}
                          required={true}
                        />
                      </Col>
                      <Col xs={6} md={2}>
                        <Controller
                          name="vat"
                          control={control}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Group>
                              <Form.Label className="form-label">
                                VAT %
                              </Form.Label>
                              <Form.Select
                                {...field}
                                size="sm"
                                disabled={viewModal}
                                onChange={(e) =>
                                  field.onChange(Number(e.target.value))
                                }
                              >
                                <option value={0}>0</option>
                                <option value={15}>15</option>
                              </Form.Select>
                            </Form.Group>
                          )}
                        />
                      </Col>
                      {watch("service_type")?.servtype_code ===
                        "itm_medcde" && (
                          <Col xs={6} md={2}>
                            <TextInput
                              name="day_supply"
                              label="Days Supply"
                              control={control}
                              disabled={viewModal}
                              size="sm"
                              type="number"
                              min={0}
                              rules={{
                                required:
                                  watch("service_type")?.servtype_code ===
                                  "itm_medcde",
                              }}
                              required={
                                watch("service_type")?.servtype_code ===
                                "itm_medcde"
                              }
                            />
                          </Col>
                        )}
                      <Col xs={6} md={4}>
                        <TextInput
                          name="preauthorization_ref_no"
                          label="Preauth ref No"
                          control={control}
                          disabled={viewModal}
                          size="sm"
                        />
                      </Col>
                    </Row>
                  </FalconComponentCard.Body>
                </FalconComponentCard>
              </Col>
              <Col xs={12} md={6}>
                <FalconComponentCard className="custom-card">
                  <FalconComponentCard.Body className="custom-body">
                    <Row className="d-flex align-items-center">
                      {!isDental && (
                        <Col xs={12} md={4}>
                          <label className="form-label">Body Site</label>
                          <Controller
                            name="body_site"
                            control={control}
                            rules={{ required: false }}
                            render={({ field }) => (
                              <MultiSelect
                                {...field}
                                menuPlacement="auto"
                                closeMenuOnSelect={false}
                                isMulti={false}
                                isClearable={true}
                                disabled={viewModal}
                                options={bodySite?.map((item) => ({
                                  value: item.bodysite_code,
                                  label: item.bodysite_display,
                                }))}
                                value={
                                  field.value
                                    ? {
                                      value: field.value.bodysite_code,
                                      label: field.value.bodysite_display,
                                    }
                                    : null
                                }
                                onChange={(selected) => {
                                  setValue(
                                    "body_site",
                                    selected
                                      ? {
                                        bodysite_code: selected.value,
                                        bodysite_display: selected.label,
                                      }
                                      : null
                                  );
                                }}
                                formatOptionLabel={({ label }) => (
                                  <div>{label}</div>
                                )}
                                getOptionValue={(option) => option.value}
                                placeholder="Choose ..."
                              />
                            )}
                          />
                        </Col>
                      )}
                      {!isDental && (
                        <Col xs={12} md={4}>
                          <label className="form-label">Sub Site</label>
                          <Controller
                            name="sub_site"
                            control={control}
                            rules={{ required: false }}
                            render={({ field }) => (
                              <MultiSelect
                                {...field}
                                menuPlacement="auto"
                                closeMenuOnSelect={false}
                                disabled={viewModal}
                                isMulti={false}
                                isClearable={true}
                                options={bodySubSite?.map((item) => ({
                                  value: item.bodysubsite_code,
                                  label: item.bodysubsite_display,
                                }))}
                                value={
                                  field.value
                                    ? {
                                      value: field.value.bodysubsite_code,
                                      label: field.value.bodysubsite_display,
                                    }
                                    : null
                                }
                                onChange={(selected) => {
                                  setValue(
                                    "sub_site",
                                    selected
                                      ? {
                                        bodysubsite_code: selected.value,
                                        bodysubsite_display: selected.label,
                                      }
                                      : null
                                  );
                                }}
                                formatOptionLabel={({ label }) => (
                                  <div>{label}</div>
                                )}
                                getOptionValue={(option) => option.value}
                                placeholder="Choose ..."
                              />
                            )}
                          />
                        </Col>
                      )}
                      {isDental && (
                        <Col xs={12} md={4}>
                          <Row>
                            <Col xs={viewModal ? 12 : 9}>
                              <label className="form-label">Oral Region</label>
                              <Controller
                                name="oral_origin"
                                control={control}
                                rules={{ required: false }}
                                render={({ field }) => (
                                  <MultiSelect
                                    {...field}
                                    menuPlacement="auto"
                                    closeMenuOnSelect={false}
                                    isMulti={false}
                                    isClearable={true}
                                    disabled={viewModal}
                                    options={oralDentalList?.map((item) => ({
                                      value: item.oral_code,
                                      label: item.oralc_description,
                                    }))}
                                    value={
                                      field.value
                                        ? {
                                          value: field.value.oral_code,
                                          label:
                                            field.value.oralc_description,
                                        }
                                        : null
                                    }
                                    onChange={(selected) => {
                                      setValue(
                                        "oral_origin",
                                        selected
                                          ? {
                                            oral_code: selected.value,
                                            oralc_description: selected.label,
                                          }
                                          : null
                                      );
                                    }}
                                    formatOptionLabel={({ label }) => (
                                      <div>{label}</div>
                                    )}
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.value}
                                    onMenuOpen={() => {
                                      setTimeout(() => {
                                        const selectedEl =
                                          document.querySelector(
                                            ".react-select__option--is-selected"
                                          );
                                        if (selectedEl) {
                                          selectedEl.scrollIntoView({
                                            block: "center",
                                            behavior: "smooth",
                                          });
                                        }
                                      }, 100);
                                    }}
                                    classNamePrefix="react-select"
                                    placeholder="Choose ..."
                                  />
                                )}
                              />
                            </Col>
                            {!viewModal && (
                              <Col xs={3}>
                                <BootIconButton
                                  onClick={() => {
                                    setTeethModal(true);
                                  }}
                                  size="small"
                                  variant="danger"
                                  className="mt-4"
                                >
                                  <FaTooth />
                                </BootIconButton>
                              </Col>
                            )}
                          </Row>
                        </Col>
                      )}
                      {isDental && (
                        <Col xs={12} md={4}>
                          <label className="form-label">Tooth Surface</label>
                          <Controller
                            name="tooth_surface"
                            control={control}
                            rules={{ required: false }}
                            render={({ field }) => (
                              <MultiSelect
                                {...field}
                                menuPlacement="auto"
                                closeMenuOnSelect={false}
                                isMulti={false}
                                isClearable={true}
                                disabled={viewModal}
                                options={bodySubSite?.map((item) => ({
                                  value: item.bodysubsite_code,
                                  label: item.bodysubsite_display,
                                }))}
                                value={
                                  field.value
                                    ? {
                                      value: field.value.bodysubsite_code,
                                      label: field.value.bodysubsite_display,
                                    }
                                    : null
                                }
                                onChange={(selected) => {
                                  setValue(
                                    "tooth_surface",
                                    selected
                                      ? {
                                        bodysubsite_code: selected.value,
                                        bodysubsite_display: selected.label,
                                      }
                                      : null
                                  );
                                }}
                                formatOptionLabel={({ label }) => (
                                  <div>{label}</div>
                                )}
                                getOptionValue={(option) => option.value}
                                placeholder="Choose ..."
                              />
                            )}
                          />
                        </Col>
                      )}
                      <Col xs={12} md={4}>
                        <label className="form-label">
                          Diagnosis <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name="diagnosis"
                          control={control}
                          rules={{
                            required: true,
                          }}
                          render={({ field }) => (
                            <MultiSelect
                              {...field}
                              menuPlacement="auto"
                              closeMenuOnSelect={false}
                              isClearable={true}
                              disabled={viewModal}
                              isMulti={true}
                              value={
                                preauthorizationDiagnosis
                                  ?.filter((d) =>
                                    (field.value || []).some(
                                      (fv) => fv?.code === d?.code
                                    )
                                  )
                                  ?.map((d) => ({
                                    label: d.description,
                                    code: d.code,
                                    value: d.code,
                                  })) || []
                              }
                              onChange={(selectedOptions) => {
                                const newValue = selectedOptions?.map(
                                  (option) => ({
                                    code: option.code,
                                    description: option.label,
                                  })
                                );
                                setValue("diagnosis", newValue);
                              }}
                              formatOptionLabel={({ label, code }) => (
                                <div>
                                  ({code}) {label}
                                </div>
                              )}
                              getOptionValue={(option) => option.code}
                              options={preauthorizationDiagnosis?.map(
                                (item) => ({
                                  label: item.description,
                                  code: item.code,
                                  value: item.code,
                                  type: item.type,
                                })
                              )}
                              placeholder="Choose ..."
                            />
                          )}
                        />
                      </Col>
                      <Col xs={12} md={4}>
                        <Form.Group controlId="service_practitioner">
                          <label className="form-label">Practitioner</label>
                          <Controller
                            name="service_practitioner"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <>
                                {console.log({ field: field.value })}
                                <MultiSelect
                                  {...field}
                                  isMulti={false}
                                  menuPlacement="auto"
                                  disabled={viewModal}
                                  options={practitionerListAdded?.map((item) => ({
                                    value: item.practitioner.value,
                                    label: item.practitioner.label,
                                  }))}
                                  placeholder="Select Practitioner"
                                  isClearable={true}
                                  value={field.value}
                                  onChange={(selected) => {
                                    setValue("service_practitioner", selected);
                                  }}
                                />
                              </>
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={4}>
                        <Form.Group controlId="lab_tests">
                          <label className="form-label">Lab Tests</label>
                          <Controller
                            name="lab_tests"
                            control={control}
                            render={({ field }) => (
                              <MultiSelect
                                {...field}
                                isMulti
                                menuPlacement="auto"
                                closeMenuOnSelect={false}
                                isClearable
                                disabled={viewModal}
                                options={labTestList?.map((test) => ({
                                  label: `${test.lab_test_code.loinc_code} - ${test.lab_test_code.loinc_description}`,
                                  value: test.lab_test_code.loinc_code,
                                  fullData: test.lab_test_code,
                                }))}
                                placeholder="Select Lab Tests"
                                value={field.value?.map((item) => ({
                                  label: `${item.loinc_code} - ${item.loinc_description}`,
                                  value: item.loinc_code,
                                  fullData: item,
                                }))}
                                onChange={(selected) => {
                                  const newValue = selected?.map(
                                    (option) => option.fullData
                                  );
                                  setValue("lab_tests", newValue);
                                }}
                                formatOptionLabel={({ label }) => (
                                  <div>{label}</div>
                                )}
                                getOptionValue={(option) => option.value}
                                components={{
                                  MultiValue: ({ data }) => (
                                    <div className="me-1">{data.label}</div>
                                  ),
                                }}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={4}>
                        <TextInput
                          name="invoice_no"
                          control={control}
                          disabled={viewModal}
                          label="Invoice No."
                          required={true}
                          size="sm"
                        />
                      </Col>
                    </Row>
                  </FalconComponentCard.Body>
                </FalconComponentCard>
              </Col>
              {(watch("service_type")?.servtype_code === "itm_medcde" ||
                watch("service_type")?.servtype_code === "itm_hrblcde") && (
                  <Col xs={12}>
                    <MedicalHistoryMedicine
                      watch={watch}
                      control={control}
                      setValue={setValue}
                    />
                  </Col>
                )}
            </Row>
            <ShowError errors={errors} />
          </Modal.Body>
          {!viewModal && (
            <Modal.Footer className="border-top pt-2">
              <Button
                variant="primary"
                type="submit"
                size="sm"
                className="fs-11"
              >
                <FontAwesomeIcon
                  icon={
                    selectedService?.invoice_no || selectedService?.id
                      ? faPen
                      : faPlus
                  }
                  className="me-2"
                />
                {selectedService?.invoice_no || selectedService?.id
                  ? "Edit Service"
                  : "Add Service"}
              </Button>
            </Modal.Footer>
          )}
        </Form>
      </Modal>
      <WizardModal
        modal={showServiceCodeModal}
        setModal={setShowServiceCodeMadal}
        title="Service Type Not Selected"
        description="Please select Service Type first before choosing Service code / description"
      />
      <TeethModalSelect
        modal={teethModal}
        setModal={setTeethModal}
      // setSelectedTooth={setSelectedTooth}
      />
    </>
  );
};

export default ClaimMedicalHistoryModal;
